module.exports = __webpack_public_path__ + "img/EagleGlobalMarkets-white.2daf5071.svg";